<template>
  <div class="row">
      <div class="col-md-4">
          <div class="form-group">
              <label>Cấp bậc</label>
              <el-select v-model="mechanism.level_select" filterable multiple collapse-tags class="w-100" placeholder="Cấp bậc" clearable>
                  <el-option
                      v-for="item in levels"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  >
                      <span style="float: left">{{ item.name }}</span>
                  </el-option>
              </el-select>
          </div>
      </div>
      <div class="col-md-4">
          <div class="form-group">
              <label>Vị trí kiêm nghiệm</label>
              <el-select class="w-100" v-model="mechanism.position_select" multiple collapse-tags @change="changePosition">
                  <el-option v-for="(item, index) in positions"
                             :key="index"
                             :label="item"
                             :value="item"
                  >
                      <span>{{ item }}</span>
                  </el-option>
              </el-select>
          </div>
      </div>
      <div class="col-md-4">
          <div class="form-group">
              <label>Khu vực</label>
              <el-select v-model="mechanism.area_select" filterable multiple collapse-tags class="w-100" placeholder="Khu vực" clearable>
                  <el-option
                      v-for="item in areas"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  >
                      <span style="float: left">{{ item.name }}</span>
                  </el-option>
              </el-select>
          </div>
      </div>
      <div class="col-md-4">
          <div class="form-group">
              <label>Văn phòng</label>
              <el-select v-model="mechanism.branch_ids" multiple  clearable class="w-100" filterable collapse-tags
                         placeholder="Nhập tên văn phòng">
                  <el-option
                      v-for="item in branches"
                      :key="item.id"
                      :label="item.name_alias ? item.name_alias : item.name"
                      :value="item.id">
                  </el-option>
              </el-select>
          </div>
      </div>
  </div>
</template>

<script>
import {GET_BRANCHES} from "@/core/services/store/center/branch.module";

export default {
    name: "ComponentMechanismDetail",
    props: {
        areas: {
            type: Array,
            default: []
        },
        levels: {
            type: Array,
            default: []
        },
        mechanism: {
          type: Object,
          default: {}
        },
    },
    data()
    {
        return {
            branches: [],
            positions: ['TPOnline', 'TVV', 'Trainer'],
            levelSelect: '',
            positionSelect: '',
            areaSelect: '',
            branchSelect: '',
        }
    },
    mounted() {
        this.getBranches();
    },
    methods: {
        getBranches() {
            this.$store.dispatch(GET_BRANCHES, {area_id: 1, all: true}).then((res) => {
                this.branches = res.data.data;
            });
        },
        changePosition()
        {

        }
    }
}
</script>

<style scoped>

</style>